// extracted by mini-css-extract-plugin
export default {"revenueTable":"DisplayRevenueData_revenueTable__nKr9l","totalRow":"DisplayRevenueData_totalRow__0QuZB"};